<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.8633 22.5V35H22.8633V22.5H35.3633V17.5H22.8633V5H17.8633V17.5H5.36328V22.5H17.8633Z"
      class="fill-current"
    />
  </svg>
</template>
